import { render } from "./ExamsResultsComponent.vue?vue&type=template&id=a716042a&scoped=true"
import script from "./ExamsResultsComponent.vue?vue&type=script&lang=js"
export * from "./ExamsResultsComponent.vue?vue&type=script&lang=js"

import "./ExamsResultsComponent.vue?vue&type=style&index=0&id=a716042a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a716042a"]])

export default __exports__